<template>
  <div class="page">
    <img src="../../assets/images/acmedback.png" class="topimg" alt="" />
    <div class="totle">
      <div class="qrcode">
        <img src="../../assets/images/acmedDownloadInfoTable.png" class="okqrcode" alt="" />
      </div>
      <div class="qrcode" @click="goToUpload()">
        <img src="../../assets/images/acmedUploadInfoTable.png" class="okqrcode" alt="" />
      </div>
      <div class="qrcode">
        <img src="../../assets/images/acmedXSZS.png" class="okqrcode1" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "uploadInfo",
  data() {
    return {};
  },
  computed: {},
  created() {
    document.title = "加入ACMED";
  },
  beforeDestroy() { },
  methods: {
    goToUpload() {
      this.$router.push({ name: 'acmedUpload' })
    }
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  position: relative;
  background: rgb(247, 249, 253);
}

.totle {
  position: absolute;
  top: 45%;
  transform: translateY(-50%);
}

.maintitle {
  margin: auto;
  text-align: center;
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 1rem;
}

.okqrcode {
  display: block;
  margin: auto;
  width: 70%;
  margin-top: 1rem;
}

.okqrcode1 {
  display: block;
  margin: auto;
  width: 55%;
  margin-top: 1rem;
}

.maininner {
  width: 73%;
  margin: auto;
  font-size: 20px;
}

.topimg {
  width: 100%;
  height: 100%;
  display: block;
}
</style>